import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Text,
  Textarea,
  VStack,
  Heading,
  useToast,
  Icon,
} from '@chakra-ui/react';
import { ElementType, useState } from 'react';
import { organizationSignUp } from '../services/organization';
import { useNavigate } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { storeData } from '../services/storage';
import { FaSave } from 'react-icons/fa';

interface OrgData {
  name: string;
  description: string;
  industry: string;
  website: string;
  email: string;
  phone_number: string;
  address: string;
  is_active: boolean;
  owner: string;
}

const AddOrganizationPage = () => {
  const toast = useToast();

  const [formData, setFormData] = useState({
    name: '',
    description: '',
    industry: '',
    website: '',
    email: '',
    phone_number: '',
    address: '',
    is_active: false,
    owner: '',
  });

  const handlePhoneChange = (value: string) => {
    const cleaned = value.replace(/\s+/g, '');
    setFormData((prev) => ({ ...prev, phone_number: cleaned }));
  };

  let [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    toast({
      title: 'Adding Organization',
      description: 'The organization is being added',
      status: 'success',
      duration: 4000,
      isClosable: true,
    });
    console.log('Organization Data:', formData);
    let storeDateResponse = await storeData(
      'orgData',
      JSON.stringify(formData),
    );
    if (storeDateResponse === 1) {
      // toast({
      //   title: 'Success',
      //   description: 'Organization Data captured successfully! Organization would be initialized on final stage.',
      //   status: 'success',
      //   duration: 4000,
      //   isClosable: true,
      // });
      navigate('/subscription');
    } else {
      toast({
        title: 'Error',
        description: `Error on creating organization`,
        status: 'error',
        duration: 4000,
        isClosable: true,
      });
    }
    // let response = await organizationSignUp(formData.name, formData.description, formData.industry, formData.website, formData.email, formData.phone_number, formData.address);
    // if(response.success == true){
    //   toast({
    //     title: 'Success',
    //     description: 'Organization created successfully!',
    //     status: 'success',
    //     duration: 4000,
    //     isClosable: true,
    //   });
    //   alert('Organization created successfully!');
    //   navigate(`/home`);
    // }else{
    //   toast({
    //     title: 'Error',
    //     description: `Error on creating organization ${response?.data}`,
    //     status: 'error',
    //     duration: 4000,
    //     isClosable: true,
    //   });
    //   console.log('error',response?.data);
    // }
  };

  return (
    <Box
      maxW="700px"
      mx="auto"
      mt={10}
      p={8}
      boxShadow="lg"
      borderRadius="md"
      bg="white"
    >
      <Heading mb={6} color="#009800ff" textAlign={'center'}>
        Add New Organization
      </Heading>
      <Text color={'red'}>{error}</Text>
      <form onSubmit={handleSubmit}>
        <VStack spacing={4} align="stretch">
          <FormControl isRequired>
            <FormLabel>Organization Name</FormLabel>
            <Input
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="e.g. Acme Inc."
              required
            />
          </FormControl>

          <FormControl isRequired>
            <FormLabel>Description</FormLabel>
            <Textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Brief summary..."
              required
            />
          </FormControl>

          <FormControl isRequired>
            <FormLabel>Industry</FormLabel>
            <Input
              name="industry"
              value={formData.industry}
              onChange={handleChange}
              placeholder="e.g. Software, Healthcare"
              required
            />
          </FormControl>

          <FormControl>
            <FormLabel>Website</FormLabel>
            <Input
              name="website"
              value={formData.website}
              onChange={handleChange}
              type="text"
              placeholder="https://example.com"
            />
          </FormControl>

          <FormControl isRequired>
            <FormLabel>Email</FormLabel>
            <Input
              name="email"
              value={formData.email}
              onChange={handleChange}
              type="email"
              required
            />
          </FormControl>

          <FormControl isRequired>
            <FormLabel>Phone</FormLabel>
            <PhoneInput
              country={'zw'} // Default country
              value={formData.phone_number}
              onChange={handlePhoneChange}
              inputStyle={{
                width: '100%',
                height: '40px',
                borderRadius: '6px',
                border: '1px solid #E2E8F0',
                paddingLeft: '48px',
              }}
              buttonStyle={{
                border: 'none',
                background: 'none',
              }}
              dropdownStyle={{
                maxHeight: '200px',
                overflowY: 'auto',
              }}
            />
          </FormControl>

          {/* <FormControl>
            <FormLabel>Phone</FormLabel>
            <PhoneInput
              country={'zw'} // Default country
              value={formData.phone_number}
              onChange={(value: string) => {
                handleChange()
              }}
              inputStyle={{
                width: '100%',
                height: '40px',
                borderRadius: '6px',
                border: '1px solid #E2E8F0',
                paddingLeft: '48px', // enough space for flag
              }}
              buttonStyle={{
                border: 'none',
                background: 'none',
              }}
              dropdownStyle={{
                maxHeight: '200px',
                overflowY: 'auto',
              }}
            />
          </FormControl> */}

          <FormControl>
            <FormLabel>Address</FormLabel>
            <Input
              name="address"
              value={formData.address}
              onChange={handleChange}
            />
          </FormControl>
          <Button
            leftIcon={<Icon as={FaSave as ElementType} boxSize={4} />}
            colorScheme="green"
            bg={'#009800ff'}
            type="submit"
          >
            Save Organization
          </Button>
        </VStack>
      </form>
    </Box>
  );
};

export default AddOrganizationPage;
